export const tomos = [
  {
    n: '1',
    title: 'Pilates Suelo (Matwork)',
    subtitle: 'Materia Prima: El Método Original',
    description:
      '40 ejercicios detallados en orden progresivo. El Hundred, Roll Up, Single Leg Circle, Teaser y todos los clásicos. La base que toda profesora necesita dominar.',
    items: [
      'Ejercicios clásicos ordenados por dificultad',
      'Correcciones exactas para cada movimiento',
      'Adaptaciones por nivel',
      'Listo para clase grupal e individual'
    ]
  },
  {
    n: '2',
    title: 'Pilates con Reformer',
    subtitle: 'El Aparato Rey: Control y Variedad Infinita',
    description:
      '40 ejercicios de Reformer organizados por objetivo. Footwork, Long Box, Jumping, Series de primavera. El tomo que te hace experta en el aparato más versátil.',
    items: [
      'Ejercicios progresivos de fácil a difícil',
      'Uso de resortes: cómo ajustar resistencia',
      'Transiciones fluidas',
      'Secuencias coreografiadas'
    ]
  },
  {
    n: '3',
    title: 'Cadillac y Silla',
    subtitle: 'Aparatos Especializados: Máxima Precisión',
    description:
      '40 ejercicios: 20 de Cadillac + 20 de Silla/Wunda Chair. Trabajo aéreo, barras, inestabilidad. Para profesoras que quieren diferenciarse.',
    items: [
      'Ejercicios en altura y suspensión',
      'Seguridad con cada movimiento',
      'Trabajo de inversión y giro',
      'Desafío y control simultáneos'
    ]
  },
  {
    n: '4',
    title: 'Pilates con Accesorios',
    subtitle: 'Herramientas Versátiles: Aro, Banda, Rodillo',
    description:
      '40 ejercicios con accesorios. Trabajo con aro mágico, bandas elásticas, rodillos y pelotas. Perfecto para clases grupales y variedad infinita.',
    items: [
      'Ejercicios con aro mágico',
      'Trabajo con bandas de resistencia',
      'Rodillos y pelotas',
      'Accesorios que potencian cada zona'
    ]
  },
  {
    n: '5',
    title: 'Pilates en Pared',
    subtitle: 'Espacio Limitado, Trabajo Máximo',
    description:
      '40 ejercicios en pared. Roll Down, Wall Angels, Prensa de piernas, Flexibilidad. El tomo para clases en estudios pequeños o para llevar a casa.',
    items: [
      'Ejercicios sin mat ni aparatos',
      'Trabajo de pared como herramienta',
      'Movilidad y fuerza integradas',
      'Accesible en cualquier lugar'
    ]
  },
  {
    n: '6',
    title: 'Pilates Terapéutico y Poblaciones Especiales',
    subtitle: 'Profesionalismo y Seguridad: Embarazo, Edad, Lesiones',
    description:
      '40 ejercicios para adultos mayores, embarazo, post-parto, hernias, escoliosis y más. El tomo que te protege legalmente y te hace experta en casos complejos.',
    items: [
      'Adaptaciones por patología',
      'Cuidados especiales documentados',
      'Ejercicios seguros y terapéuticos',
      'Protocolo claro para cada caso'
    ]
  }
];
